import { apiClient, ApiResponse } from '../../utils/axiosWithAuth';
import { StockLogResponse, StockLogFilters, StockLogEntry } from './types';

export const fetchStockLogsAPI = async (
  filters: StockLogFilters = {}
): Promise<StockLogResponse> => {
  try {
    const params = new URLSearchParams();

    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.search) params.append('search', filters.search);
    if (filters.itemUuid) params.append('itemUuid', filters.itemUuid);
    if (filters.updatedBy) params.append('updatedBy', filters.updatedBy);
    if (filters.updateSource) params.append('updateSource', filters.updateSource);
    if (filters.storeId) params.append('storeId', filters.storeId);
    if (filters.supplierId) params.append('supplierId', filters.supplierId);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);

    const response = await apiClient.get(`/stock-logs?${params.toString()}`);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching stock logs:', error);
    return {
      status: false,
      data: [],
      pagination: { page: 1, limit: 20, total: 0, totalPages: 0 },
    };
  }
};

export const exportStockLogsAPI = async (
  filters: Omit<StockLogFilters, 'page' | 'limit'> = {}
): Promise<{ status: boolean; data: StockLogEntry[]; total: number }> => {
  try {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.itemUuid) params.append('itemUuid', filters.itemUuid);
    if (filters.updatedBy) params.append('updatedBy', filters.updatedBy);
    if (filters.updateSource) params.append('updateSource', filters.updateSource);
    if (filters.storeId) params.append('storeId', filters.storeId);
    if (filters.supplierId) params.append('supplierId', filters.supplierId);
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortOrder) params.append('sortOrder', filters.sortOrder);

    const response = await apiClient.get(`/stock-logs/export?${params.toString()}`);
    return response.data;
  } catch (error: any) {
    console.error('Error exporting stock logs:', error);
    return { status: false, data: [], total: 0 };
  }
};
